import { Field, Form, Formik, ErrorMessage } from "formik";
import Modal from "react-bootstrap/Modal";
import * as Yup from 'yup';
import { useFilterStore } from "../AssetVehicle/store/useFilterStore";
import { useEffect } from "react";
import RouteSupervisorStore from "../RouteSupervisor/store/routeSupervisorStore";
import RouteMastersStore from "./store/useRouteMasterStore";
import { toast } from "react-toastify";
const AddRouteMasterModal = ({ showModal, setShow, selectedData }) => {
    const { zones, allCircles, fetchFilterZones,
        fetchAllCircles, } = useFilterStore()
    const { fetchRouteSupervisorData, routeSupervisorData } = RouteSupervisorStore();
    const { fetchRouteMasters, addRouteMasterData, updateRouteMasterData } = RouteMastersStore()
    useEffect(() => {
        fetchFilterZones()
        fetchAllCircles()
        fetchRouteSupervisorData()
    }, [])

    const handleClose = () => {
        setShow(false)
    }

    const initialValues = {
        routeCode: selectedData ? selectedData.routeCode : "",
        routeName: selectedData ? selectedData.routeName : "",
        zoneId: selectedData ? selectedData.zoneId : "",
        circleId: selectedData ? selectedData.circleId : "",
        routeSupervisorId: selectedData ? selectedData.routeSupervisorId : null,
        status:
            selectedData && selectedData.status !== undefined
                ? selectedData.status === "Active" || selectedData.status === "true"
                    ? "true"
                    : "false"
                : "true",
    };

    const validationSchema = Yup.object().shape({
        routeCode: Yup.string().required("Route Code Required"),
        routeName: Yup.string().required("Route Name Required"),
        zoneId: Yup.string().required("Zone Name Required"),
        circleId: Yup.string().required("Circle Name Required"),
        // routeSupervisorId: Yup.string().required("Supervisor Required")

    })

    const handleSubmit = async (values, { resetForm, setSubmitting }) => {
        const updatedValues = {
            ...values,
            zoneId: Number(values.zoneId),
            circleId: Number(values.circleId),
            routeSupervisorId: (values.routeSupervisorId) || null,
            status: values.status === 'true'
        };

        let response;
        if (selectedData) {
            response = await updateRouteMasterData({
                ...updatedValues,
                routeId: selectedData.routeId
            });
        } else {
            response = await addRouteMasterData(updatedValues);
        }
        if (response.success === true) {
            resetForm();
            handleClose();
            fetchRouteMasters();
        }
        setSubmitting(false);
    };

    return (
        <Modal
            show={showModal}
            size="lg"
            aria-labelledby="example-modal-sizes-title-lg"
            backdrop="static">
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    {selectedData ? "Edit Route Master" : " Add Route Master"}
                </Modal.Title>
                <i
                    className="fa-solid fa-xmark close-container"
                    onClick={handleClose}
                ></i>
            </Modal.Header>
            <hr />
            <Modal.Body>
                <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
                    {({ isSubmitting, values }) => (
                        <Form>
                            <div className="row">
                                <div className="col-md-4 mb-3">
                                    <label htmlFor="routeCode">
                                        Route Code <span className="text-danger">*</span>
                                    </label>
                                    <Field
                                        name="routeCode"
                                        render={({ field }) => (
                                            <input
                                                {...field}
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Route Code"
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.replace(/[^A-Za-z0-9]/g, '');
                                                }}
                                            />
                                        )}
                                    />

                                    <ErrorMessage
                                        name="routeCode"
                                        component="div"
                                        style={{ color: 'red' }} className='small' />
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label htmlFor="routeName">
                                        Route Name <span className="text-danger">*</span>
                                    </label>
                                    <Field
                                        name="routeName"
                                        render={({ field }) => (
                                            <input
                                                {...field}
                                                type="text"
                                                className="form-control"
                                                  placeholder="Enter Route Name"
                                                onInput={(e) => {
                                                    let value = e.target.value;

                                                    // Allow A-Z, a-z, 0-9, space, /, and -
                                                    // value = value.replace(/[^A-Za-z0-9 /-]/g, '');
                                                    value = value.replace(/\s+/g, ' ');

                                                    // Remove leading and trailing spaces
                                                    value = value.trimStart();

                                                    e.target.value = value;
                                                }}
                                            />
                                        )}
                                    />


                                    <ErrorMessage
                                        name="routeName"
                                        component="div"
                                        style={{ color: 'red' }} className='small' />
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label htmlFor="zoneId">
                                        Zone <span className="text-danger">*</span>
                                    </label>
                                    <Field as="select" className="form-select" name="zoneId">
                                        <option value="">Select</option>
                                        {zones
                                            .filter((zone) => zone.isActive)
                                            .map((zone) => (
                                                <option key={zone.zoneId} value={zone.zoneId}>
                                                    {zone.zoneName}
                                                </option>
                                            ))}
                                    </Field>

                                    <ErrorMessage
                                        name="zoneId"
                                        component="div"
                                        style={{ color: 'red' }} className='small' />
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label htmlFor="circleId">
                                        Ward <span className="text-danger">*</span>
                                    </label>
                                    <Field as="select" className="form-select" name="circleId">
                                        <option value="">Select</option>
                                        {allCircles
                                            .filter((circle) => circle.isActive && (circle.zoneId == values.zoneId))
                                            .map((circle) => (
                                                <option key={circle.circleId} value={circle.circleId}>
                                                    {circle.circleName}
                                                </option>
                                            ))}
                                    </Field>

                                    <ErrorMessage
                                        name="circleId"
                                        component="div"
                                        style={{ color: 'red' }} className='small' />
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label htmlFor="routeSupervisorId">
                                        Route Supervisor 
                                    </label>
                                    <Field as="select" className="form-select" name="routeSupervisorId">
                                        <option value="">Select </option>
                                        {routeSupervisorData
                                            .filter((supervisor) => supervisor.isActive)
                                            .map((supervisor) => (
                                                <option key={supervisor.routeSupervisorId} value={supervisor.routeSupervisorId}>
                                                    {supervisor.routeSupervisorName}
                                                </option>
                                            ))}
                                    </Field>
                                    {/* <ErrorMessage
                                        name="routeSupervisorId"
                                        component="div"
                                        style={{ color: 'red' }} className='small' /> */}
                                </div>
                                <div className="col-md-4 ">
                                    <label className="form-label">
                                        Status<span style={{ color: "#EC1117" }}> *</span>
                                    </label>
                                    <div className="form-group" style={{ display: "flex", alignItems: 'center' }}>
                                        <div className="form-check d-flex">
                                            <Field
                                                type="radio"
                                                className="form-check-input"
                                                name="status"
                                                id="activeRadio"
                                                value="true"
                                            />
                                            <label className="form-check-label" htmlFor="activeRadio">
                                                Active
                                            </label>
                                        </div>
                                        <div className="form-check ms-4 d-flex">
                                            <Field
                                                type="radio"
                                                className="form-check-input"
                                                name="status"
                                                id="inactiveRadio"
                                                value="false"
                                            />
                                            <label className="form-check-label" htmlFor="inactiveRadio">
                                                Inactive
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer d-flex justify-content-center">
                                {/* {canWriteValue === true ? */}
                                <button type="submit" className="deployment-button"
                                    disabled={isSubmitting}
                                >
                                    <i class="fa-solid fa-check done-container"></i>
                                    {selectedData ? ("Update") : ("Save")}
                                    {/* Save */}
                                </button>
                                {/* : ''} */}
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>

        </Modal>
    )
}
export default AddRouteMasterModal